import { createModuleContext } from '@rebuild/utils/moduleContext';

const MODULE_NAME = 'question';

function buildBaseCtx() {
	return {
		showTabs: true,
		questionTabList: []
	};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

export { provideCurrentContext, useCurrentContext };
